import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
export type Analytics_Eccomerce_FragmentFragment = {
    __typename?: 'AnalyticsEcommerce';
} & Pick<Types.AnalyticsEcommerce, 'currencyCode'> & {
        impressions?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'AnalyticsEcommerceImpressions' } & Pick<
                        Types.AnalyticsEcommerceImpressions,
                        'id' | 'list' | 'position' | 'variant'
                    >
                >
            >
        >;
    };

export const Analytics_Eccomerce_FragmentFragmentDoc = gql`
    fragment ANALYTICS_ECCOMERCE_FRAGMENT on AnalyticsEcommerce {
        currencyCode
        impressions {
            id
            list
            position
            variant
        }
    }
`;
